/* eslint-disable import/no-cycle */
import { loginApi, loginUser, logoutUser } from '@api'
import { error } from '@core/utils/toasted'
import useCryptoJs from '@core/utils/useCryptoJs'

// eslint-disable-next-line object-curly-newline
import { LOGIN_USER, LOGOUT_USER, UPDATE_PERSON, UPDATE_USER_AVATAR, REFRESH_SESSION } from '../mutation-types'
import router from '../../router'

const { decryptData } = useCryptoJs()

export default {
  namespaced: true,
  state: {
    user: {},
    userAvatar: null,
    logged: false,
    accessToken: null,
    refreshToken: null,
  },
  getters: {
    user: state => state.user,
    accessToken: state => state.token,
    refreshToken: state => state.refreshToken,
  },
  mutations: {
    [LOGIN_USER](state, payload) {
      state.user = payload
      state.logged = true
      state.accessToken = payload.access_token
      state.refreshToken = payload.refresh_token
    },
    [LOGOUT_USER](state) {
      state.user = {}
      state.userAvatar = null
      state.logged = false
      state.accessToken = null
      state.refreshToken = null
    },
    [UPDATE_USER_AVATAR](state, payload) {
      state.userAvatar = payload
    },
    [UPDATE_PERSON](state, payload) {
      state.user.person = {
        ...state.user.person,
        ...payload,
      }
    },
    [REFRESH_SESSION](state, payload) {
      state.user = {
        ...state.user,
        ...payload,
      }
      state.accessToken = payload.access_token
      state.refreshToken = payload.refresh_token
    },
  },
  actions: {
    async loginAction({ commit }, payload) {
      const serviceResponse = await loginApi(payload)
      if (serviceResponse.ok) {
        const userAbility = [
          {
            action: 'manage',
            subject: 'all',
          },
        ]

        // const userAbility = [
        //   {
        //     action: 'read',
        //     subject: 'ACL',
        //   },
        //   {
        //     action: 'read',
        //     subject: 'Demo',
        //   },
        //   {
        //     action: 'read',
        //     subject: 'Public',
        //   },
        // ]

        // localStorage.setItem('userAbility', JSON.stringify(userAbility))

        // const { user } = response.data
        // const { ability: userAbility } = user

        // Set user ability
        // ? https://casl.js.org/v5/en/guide/intro#update-rules
        // vm.$ability.update(userAbility)

        // Set user's ability in localStorage for Access Control
        localStorage.setItem('userAbility', JSON.stringify(userAbility))
        const user = serviceResponse.data
        const data = decryptData(user)
        localStorage.setItem('userData', JSON.stringify(user))
        localStorage.setItem('userAvatar', JSON.stringify(data.avatar || null))
        localStorage.setItem('accessToken', data.access_token)
        localStorage.setItem('refreshToken', data.refresh_token)

        // We will store `userAbility` in localStorage separate from userData
        // Hence, we are just removing it from user object
        // delete user.ability

        // Set user's data in localStorage for UI/Other purpose
        // localStorage.setItem('userData', JSON.stringify(user))

        commit(LOGIN_USER, serviceResponse.data)
        commit(UPDATE_USER_AVATAR, data.avatar)

        // On success redirect to home
        router.push('/')
      } else {
        error(serviceResponse.message.text)
        router.push({ name: 'auth-login' })
      }
    },

    async loginUserAction({ commit }, payload) {
      const serviceResponse = await loginUser(payload.data)
      if (serviceResponse.ok) {
        const userAbility = [
          {
            action: 'manage',
            subject: 'all',
          },
        ]

        localStorage.setItem('userAbility', JSON.stringify(userAbility))
        const user = serviceResponse.data
        const data = decryptData(user)
        localStorage.setItem('matchCode', JSON.stringify(data.match_code))
        localStorage.setItem('userData', JSON.stringify(user))
        localStorage.setItem('accessToken', data.access_token)
        localStorage.setItem('refreshToken', data.refresh_token)

        commit(LOGIN_USER, serviceResponse.data)
        commit(UPDATE_USER_AVATAR, data.avatar || null)
        if (payload.redirect === 'deletion-request') router.push({ name: 'views-deletion-request' })

        // remove team
        if (payload.redirect === 'reservation') {
          const params = {
            code: payload.reservationCode,
            showPay: payload.showPay,
            payType: payload.payType,
          }
          if (payload.team && payload.team !== 'UNDEFINED') params.team = payload.team
          router.push({
            name: 'reservation',
            params,
          })
        }

        if (payload.redirect === 'landing') {
          const params = {
            code: data.match_code,
            selected: payload.slot,
            pay: payload.pay,
            chooseTeam: payload.chooseTeam,
          }
          if (payload.team && payload.team !== 'UNDEFINED') params.team = payload.team
          router.push({
            name: 'public',
            params,
          })
        }

        if (payload.redirect === 'videos') {
          router.push({
            name: 'views-video',
            params: {
              facility: payload.facility.id,
              field: payload.field || 'all',
              date: payload.date || 'all',
              time: payload.time || 'all',
            },
          })
        }

        if (payload.redirect === 'facilities') router.push({ name: 'views-facility-list' })
      }
    },

    async refreshApp({ commit }, payload) {
      commit(REFRESH_SESSION, payload)

      // trycatch in case app reload same route
      try {
        router.push({ name: 'dashboard-crm' }) // dashboard-crm

        // const userData = JSON.parse(localStorage.getItem('userData'))
        // const userRole = userData && userData.role ? userData.role : null
        // if (userRole === 'admin') return { router.push({ name: 'dashboard-crm' }) }
        // if (userRole === 'client') return { router.push({ name: 'page-access-control' }) }
      } catch (e) {
        // error case
      }
    },

    async logoutSuccess({ commit }) {
      const lang = localStorage.getItem('lang') || 'es'
      await localStorage.clear()
      commit(LOGOUT_USER)

      // localStorage.setItem('matchCode', JSON.stringify(code))
      localStorage.setItem('lang', JSON.stringify(lang))
      if (!['views-facility-list', 'reservation', 'match', 'public'].includes(router.history.current.name)) {
        router.push({ name: 'views-facility-list' })
      }
    },

    async logoutAction({ commit }) {
      const { userData } = useCryptoJs()

      // const code = JSON.parse(localStorage.getItem('matchCode'))
      const lang = localStorage.getItem('lang')

      const logout = {
        access_token: userData.value.access_token,
        refresh_token: userData.value.refresh_token,
        expo_token: '',
      }
      const logouteResponse = await logoutUser(logout)

      if (logouteResponse.ok) {
        const storedCode = localStorage.getItem('matchCode')
        const matchCode = storedCode ? storedCode.replaceAll('"', '') : ''
        await localStorage.clear()
        commit(LOGOUT_USER)

        // localStorage.setItem('matchCode', JSON.stringify(code))
        localStorage.setItem('lang', JSON.stringify(lang))
        if (['pay-booking'].includes(router.history.current.name)) {
          // eslint-disable-next-line no-underscore-dangle
          const { selected, team } = router.app._route.params
          const params = { code: matchCode, selected }
          if (team && team !== 'UNDEFINED') params.team = team
          router.push({ name: 'public', params })
        } else if (['choose-team'].includes(router.history.current.name)) {
          // const { code, team } = router.app._route.params
          // eslint-disable-next-line no-underscore-dangle
          const { team } = router.app._route.params
          const params = { code: matchCode }
          if (team && team !== 'UNDEFINED') params.team = team
          router.push({ name: 'public', params })
        } else if (!['views-facility-list', 'reservation', 'match', 'public'].includes(router.history.current.name)) {
          router.push({ name: 'views-facility-list' })
        }
      }
    },
  },
}
